import React from 'react';
import styled from 'styled-components';
import Rating from '@material-ui/lab/Rating';
export const RateWithNumber = (props) => {
    const { value, size } = props;
    let fontSize = '16px';
    switch (size) {
        case 'large':
            fontSize = '40px';
            break;
        case 'medium':
            fontSize = '28px';
            break;
        default:
            break;
    }
    return (React.createElement(SRateArea, null,
        React.createElement(SRating, { size: size, value: value, readOnly: true, precision: 0.1 }),
        React.createElement(SNumber, { fontSize: fontSize }, value.toFixed(1))));
};
const SRateArea = styled.div `
  display: flex;
  align-items: center;
`;
const SRating = styled(Rating) `
  margin-right: 12px;
`;
const SNumber = styled.p `
  margin: 0;
  font-size: ${({ fontSize }) => fontSize};
  font-weight: bold;
  font-family: Roboto;
`;
